import React,{ createContext, useContext, useReducer } from 'react';

const ProfileContext = createContext(window.owner_main_vars);
const reducer = (state, action) => {
	switch (action.type) {
		case 'TOGGLE_TEST':
			return {
				...state,
				promotion:{
					...state.promotion,
					Promotion:{
						...state.promotion.Promotion,
						test:action.test_mode
					}
				}
			}
	
		default:
			return state;
	}
}

export const ProfileProvider = (props) => {
	const [ data, dispatch ] = useReducer(reducer, window.owner_main_vars);
	return (

		<ProfileContext.Provider value={{...data,dispatch}}>
			{props.children}
		</ProfileContext.Provider>
	)
};

export const useOwner = () => {
	return useContext(ProfileContext);
};